import { render, staticRenderFns } from "./ProjectBookAssistant.vue?vue&type=template&id=f95b4926&scoped=true&lang=pug&"
import script from "./ProjectBookAssistant.vue?vue&type=script&lang=ts&"
export * from "./ProjectBookAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b4926",
  null
  
)

export default component.exports